<template>
  <div class="project-metting">
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="depName" label="所属公司" width="160px">
      </el-table-column>
      <el-table-column label="会议名称">

        <template slot-scope="scope">
          <a href="javascript:;" class="link" @click="showMeetingInfo(scope.row.id)">{{ scope.row.name }}</a>
          <el-tooltip v-if="scope.row.isHasAttas" class="item" effect="dark" content="点击查看会议资料" placement="bottom">
            <i @click="showMeetingInfo(scope.row.id)" class="el-icon-document meeting-name-icon"></i>
          </el-tooltip>
        </template>

      </el-table-column>
      <el-table-column prop="address" label="会议室地址">
      </el-table-column>
      <el-table-column label="参会人员" width="250px">
        <template slot-scope="scope">
          <div v-html="getUserList(scope.row.joinUsers)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="conferenceTime" label="会议时间" width="120px">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="60px">
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 会议资料详情 -->
    <meeting-info v-if="meetingInfoStatus" :meetingId="meetingId" :meetingInfoStatus="meetingInfoStatus"
      v-on:hideMeetingInfo="hideMeetingInfo()"></meeting-info>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import MeetingInfo from '@/components/MeetingInfo'
  import meetingMixin from '@/Mixins/meetingMixin'
  export default {
    mixins: [meetingMixin],
    props: ['projectId'],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
      })
    },
    components: {
      MeetingInfo,
    },
    data() {
      return {
        // 会议资料详情
        meetingInfoStatus: false,
        meetingId: "",

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      console.log(this.projectId)
      // 获取列表
      this.getLists()
    },
    methods: {
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/gc/project/conference/' + this.projectId, '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {

    }
  };

</script>



// WEBPACK FOOTER //
// src/page/project/metting.vue